import React from "react";
import { Controller } from "react-hook-form";
import Datepicker from "react-tailwindcss-datepicker";
import dayjs from "dayjs";
import { useUserRole } from "../utils/helperMethods";

const DatePickerController = ({
  control,
  fieldName,
  minDate,
  value,
  disableMinDate = false,
}) => {
  const today = dayjs();
  const twoWeeks = today.add(14, "day");
  const minimumDate = dayjs(minDate);

  const userRole = useUserRole();
  const dateRestriction = userRole === "admin" ? twoWeeks : minimumDate;

  const toDateObj = (date) => (date ? dayjs(date).toDate() : null);

  const toDateString = (date) =>
    date ? dayjs(date).format("YYYY-MM-DD") : null;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => {
        const normalizedValue =
          field.value ||
          (value
            ? {
                startDate: toDateObj(value),
                endDate: toDateObj(value),
              }
            : null);

        return (
          <div className="relative w-full">
            <Datepicker
              {...field}
              name={fieldName}
              value={normalizedValue}
              onChange={(selectedDate) => {
                const normalized = selectedDate
                  ? {
                      startDate: toDateString(selectedDate.startDate),
                      endDate: toDateString(selectedDate.endDate),
                    }
                  : null;
                // Store safe string in form
                field.onChange(normalized);
              }}
              placeholder="Select Date"
              useRange={false}
              displayFormat="MMMM DD, YYYY"
              asSingle
              minDate={disableMinDate ? null : toDateObj(dateRestriction)}
              containerClassName="datepicker-dropdown w-full z-50"
              popperClassName="w-full z-50 p-2 border border-gray-300 rounded-md shadow-lg bg-white"
              inputClassName="w-full z-50 border border-gray-300 rounded-md px-3 py-2 text-sm text-black focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
            />
          </div>
        );
      }}
    />
  );
};

export default DatePickerController;
